// extracted by mini-css-extract-plugin
export default {"productsPageContainer":"productsPage_productsPageContainer__bLDxW","showProduct":"productsPage_showProduct__TYvX2"};